module.exports = __webpack_public_path__ + "static/media/service_brunch.046f6926.jpg";